/**
 * Constants
 */
export enum Constants {
    DATEFORMAT = 'YYYY-MM-DD',
    DATETIMEFORMAT = 'YYYY-MM-DD HH:mm:ss',
    // DATETIME_TZ_FORMAT = 'YYYY-MM-DD HH:mm:ss Z',
    DATETIME_TZ_FORMAT = 'YYYY-MM-DD HH:mm:ss',
    CONTACT = 'CONTACT',
    BRANCH = 'BRANCH',
    PAYMENT_CONFIG = 'PAYMENT_CONFIG',
    TAX_DETAILS = 'TAX_DETAILS',
    SHIPPING_ADDRESS = 'SHIPPING_ADDRESS',
    BILLING_ADDRESS = 'BILLING_ADDRESS',
    MAIN_ADDRESS = 'MAIN_ADDRESS',
    CREDIT_TERMS = 'CREDIT_TERMS',
    CREDIT_LIMITS = 'CREDIT_LIMITS',
    LIST_CATEGORY_GUID = 'LIST_CATEGORY_GUID',
    REMARKS = 'REMARKS',
    CURRENCY = 'CURRENCY',
    GENDER = 'GENDER',
    GLCODE_INFO = 'GLCODE_INFO',
    ID_NO = 'ID_NO',
    TAX_REG_NO = 'TAX_REG_NO',
}

export const STATUS = [
    'ACTIVE',
    'INACTIVE'
];

export const ENTITY_TYPE = [
    'CUSTOMER',
    'SUPPLIER',
    'EMPLOYEE',
    'MERCHANT'
];

export const TYPE = [
    'CORPORATE',
    'INDIVIDUAL'
];

/**
 * For string values
 */
interface Option {
    value: string;
    viewValue: string;
  }

export class ARAPTypeOptions {
    public static values: Option[] = [
        { value: 'AR_TRADE', viewValue: 'AR_TRADE' },
        { value: 'AR_OTHER', viewValue: 'AR_OTHER' },
        { value: 'AR_MERCHANT', viewValue: 'AR_MERCHANT' },
        { value: 'AP_TRADE', viewValue: 'AP_TRADE' },
        { value: 'AP_OTHER', viewValue: 'AP_OTHER' },
        { value: 'AP_MERCHANT', viewValue: 'AP_MERCHANT' },
        { value: 'AP_EMPLOYEE', viewValue: 'AP_EMPLOYEE' }
    ];
}

export class EntityTypeOptions {
    public static values: Option[] = [
        { value: 'CUSTOMER', viewValue: 'CUSTOMER' },
        { value: 'SUPPLIER', viewValue: 'SUPPLIER' },
        { value: 'EMPLOYEE', viewValue: 'EMPLOYEE' },
        { value: 'MERCHANT', viewValue: 'MERCHANT' },
    ];
}

export class TypeOptions {
    public static values: Option[] = [
        { value: 'CORPORATE', viewValue: 'CORPORATE' },
        { value: 'INDIVIDUAL', viewValue: 'INDIVIDUAL' }
    ];
}

export class StatusOptions { 
    public static values: Option[] = [
        { value: 'ACTIVE', viewValue: 'ACTIVE' },
        { value: 'INACTIVE', viewValue: 'INACTIVE' }
    ];
    }

export class GenderOptions { 
    public static values: Option[] = [
        { value: 'MALE', viewValue: 'MALE' },
        { value: 'FEMALE', viewValue: 'FEMALE' },
        { value: 'TRANS', viewValue: 'TRANSGENDER' },
        { value: 'RNS', viewValue: 'RATHER NOT SAY' },
    ];
}

export class MaritalStatusOptions { 
    public static values: Option[] = [
        { value: 'M', viewValue: 'MARRIED' },
        { value: 'S', viewValue: 'SINGLE' },
        { value: 'O', viewValue: 'OTHER' }
    ];
}

export class SettlementTypeOptions {
    public static values: Option[] = [
        { value: 'BANK_TRANSFER', viewValue: 'Bank Transfer' },
        { value: 'CASH', viewValue: 'Cash' },
        { value: 'CHEQUE', viewValue: 'Cheque' },
        { value: 'CREDIT_CARD', viewValue: 'Credit Card' },
        { value: 'E_WALLET', viewValue: 'e-Wallet' },
        { value: 'FPX_EMANDATE', viewValue: 'FPX e-Mandate' },
        { value: 'PAYMENT_GATEWAY', viewValue: 'Payment Gateway' },
        { value: 'MEMBERSHIP_POINT_CURRENCY', viewValue: 'Membership Point Currency' },
        { value: 'OPEN_CREDIT', viewValue: 'Open Credit' },
        { value: 'OTHERS', viewValue: 'Others' },
        { value: 'VOUCHER', viewValue: 'Voucher' }
    ];
}

/**
 * For int values
 */
interface IntOption {
value: number;
viewValue: string;
}

export class MonthOptions {
    public static values: IntOption[] = [
        { value: 1, viewValue: 'January' },
        { value: 2, viewValue: 'February' },
        { value: 3, viewValue: 'March' },
        { value: 4, viewValue: 'April' },
        { value: 5, viewValue: 'May' },
        { value: 6, viewValue: 'June' },
        { value: 7, viewValue: 'July' },
        { value: 8, viewValue: 'August' },
        { value: 9, viewValue: 'September' },
        { value: 10, viewValue: 'October' },
        { value: 11, viewValue: 'November' },
        { value: 12, viewValue: 'December' }
    ]
}

export class IDTypeOptions {
    public static values: Option[] = [
      { value: 'PASSPORT', viewValue: 'PASSPORT' },
      // { value: 'IDENTITY_CARD', viewValue: 'IDENTITY CARD (IC)' },
      { value: 'NRIC', viewValue: 'NRIC' },
      { value: 'BRN', viewValue: 'BRN' },
      { value: 'ARMY', viewValue: 'ARMY' }
    ];
  }